import { PhoneField, PhoneFieldProps } from './PhoneField';
export type { PhoneFieldProps };
export default PhoneField;
